import { yesNoList } from '@/constants';
export const baseFromColumns = (ctx) => {
  return [
    {
      prop: 'projectInitiationCreateDate',
      name: '制单日期',
      type: 'date',
      format: 'yyyy-MM-dd',
      disabled: true,
      showTag: ctx.baseFormData.changeFields?.includes('projectInitiationCreateDate'),
    },
    {
      //立项编号
      prop: 'projectInitiationNo',
      name: '立项编号',
      type: 'input',
      disabled: true,
      placeholder: '自动生成',
      showTag: ctx.baseFormData.changeFields?.includes('projectInitiationNo'),

      // isHidden: ctx.isCreate,
    },
    {
      prop: 'businessType', // TODO:
      name: '业务类型',
      type: 'select',
      options: ctx.dictListMap?.GoodsTradeProject_businessType || [],
      showTag: ctx.baseFormData.changeFields?.includes('businessType'),
    },
    {
      prop: 'projectName',
      name: '项目名称',
      type: 'input',
      maxlength: 80,
      showTag: ctx.baseFormData.changeFields?.includes('projectName'),
    },
    {
      prop: 'projectAddress', // TODO:
      name: '项目地点',
      type: 'input',
      showTag: ctx.baseFormData.changeFields?.includes('projectAddress'),
    },
    {
      prop: 'subjectMatter', // TODO:
      name: '标的物',
      type: 'dict',
      dictType: 'PROJECT_INITIATION_SUBJECT_MATTER',
      showTag: ctx.baseFormData.changeFields?.includes('subjectMatter'),
    },

    {
      prop: 'platformtCompanyName',
      name: '平台公司',
      type: 'select',
      options: ctx.companyList1,
      multiple: true,
      showTag: ctx.baseFormData.changeFields?.includes('platformtCompanyName'),
    },
    {
      prop: 'applyDepartmentNo',
      name: '申请部门',
      type: 'select',
      options: ctx.departmentList,
      showTag: ctx.baseFormData.changeFields?.includes('applyDepartmentNo'),
    },
    {
      prop: 'supplierNo',
      name: '供应商名称',
      type: 'searchTableSpec',
      // isMultiple: true,
      searchType: 'partner',
      getSearchCode: 'partnerCode',
      extraData: {
        adminFlag: ctx.userInfo.adminFlag,
        companyCode: ctx.userInfo?.companyCode,
        departmentCode: ctx.userInfo?.departmentCode,
        partnerTypes: 'HZHB02,HZHB03', // 客户、供应商、合作伙伴
      },
      currentValue: ctx.baseFormData.supplierName ? ctx.baseFormData.supplierName.join(',') : null,
      checkRowKeys: ctx.baseFormData.supplierNo,
      showTag: ctx.baseFormData.changeFields?.includes('supplierNo'),
    },
    {
      prop: 'customerNo',
      type: 'searchTableSpec',
      name: '客户名称',
      searchType: 'supplier',
      extraData: {
        partnerTypes: 'HZHB03,HZHB01',
        departmentCode: ctx.userInfo.departmentCode,
        companyCode: ctx.userInfo.companyCode,
      },
      currentValue: ctx.baseFormData.customerName ? ctx.baseFormData.customerName.join(',') : null,
      checkRowKeys: ctx.baseFormData.customerNo,
      showTag: ctx.baseFormData.changeFields?.includes('customerNo'),
    },
    {
      prop: 'chargePersonNo',
      name: '负责人',
      type: 'searchTableSpec',
      searchType: 'personnel',
      currentValue: ctx.baseFormData.chargePersonName ? ctx.baseFormData.chargePersonName : null,
      checkRowKeys: [ctx.baseFormData.chargePersonNo ? ctx.baseFormData.chargePersonNo : null],
      isMultiple: true,
      showTag: ctx.baseFormData.changeFields?.includes('chargePersonNo'),
    },
    {
      prop: 'declareDate', // TODO
      name: '申报日期',
      type: 'date',
      disabled: true,
      showTag: ctx.baseFormData.changeFields?.includes('declareDate'),
    },
    {
      prop: 'projectUsageQuotaWan',
      name: '使用额度',
      type: 'inputNumber',
      append: '万元',
      showTag: ctx.baseFormData.changeFields?.includes('projectUsageQuotaWan'),
    },
    {
      prop: 'projectAccountingPeriod',
      name: '项目账期',
      type: 'inputNumber',
      append: '天',
      showTag: ctx.baseFormData.changeFields?.includes('projectAccountingPeriod'),
    },
    {
      prop: 'projectReceivableQuotaWan',
      name: '应收账款额度',
      type: 'inputNumber',
      append: '万元',
      showTag: ctx.baseFormData.changeFields?.includes('projectReceivableQuotaWan'),
    },
    {
      prop: 'operatingRevenueTarget',
      name: '营业收入目标',
      type: 'inputNumber',
      append: '万元',
      showTag: ctx.baseFormData.changeFields?.includes('operatingRevenueTarget'),
    },
    {
      prop: 'profitTarget', // TODO
      name: '利润目标',
      type: 'inputNumber',
      append: '万元',
      showTag: ctx.baseFormData.changeFields?.includes('profitTarget'),
    },
    {
      prop: 'projectNetProfitRate', // TODO
      name: '项目净利润率',
      type: 'inputNumber',
      disabled: true,
      append: '%',
      showTag: ctx.baseFormData.changeFields?.includes('projectNetProfitRate'),
    },
    {
      prop: 'grossProfitRate', // TODO
      name: '毛利率',
      type: 'inputNumber',
      append: '%',
      showTag: ctx.baseFormData.changeFields?.includes('grossProfitRate'),
    },
    {
      prop: 'deliveryQuantity',
      name: '发货数量',
      type: 'input',
      showTag: ctx.baseFormData.changeFields?.includes('deliveryQuantity'),

      // append: '吨',
    },
    {
      prop: 'costPrediction', // TODO
      name: '营业成本',
      type: 'inputNumber',
      append: '万元',
      showTag: ctx.baseFormData.changeFields?.includes('costPrediction'),
    },
    {
      prop: 'costOfFunds', // TODO
      name: '资金成本',
      type: 'inputNumber',
      append: '万元',
      showTag: ctx.baseFormData.changeFields?.includes('costOfFunds'),
    },
    {
      prop: 'taxCost', // TODO
      name: '税费成本',
      type: 'inputNumber',
      append: '万元',
      showTag: ctx.baseFormData.changeFields?.includes('taxCost'),
    },
    {
      prop: 'sellingExpenses', // TODO
      name: '销售费用',
      type: 'inputNumber',
      append: '万元',
      showTag: ctx.baseFormData.changeFields?.includes('sellingExpenses'),
    },
    {
      prop: 'projectMonthlyReturnRate', // TODO
      name: '项目月收益率',
      type: 'inputNumber',
      append: '%',
      showTag: ctx.baseFormData.changeFields?.includes('projectMonthlyReturnRate'),
    },
    {
      prop: 'effectiveDateOfYield', // TODO
      name: '收益率生效日期',
      type: 'date',
      showTag: ctx.baseFormData.changeFields?.includes('effectiveDateOfYield'),
    },
    {
      prop: 'upstreamSettlementAdjustment', // TODO
      name: '上游结算调整',
      type: 'inputNumber',
      showTag: ctx.baseFormData.changeFields?.includes('upstreamSettlementAdjustment'),
    },
    {
      prop: 'upstreamSettlementAdjustmentValue', // TODO
      name: '上游结算调整值',
      type: 'inputNumber',
      showTag: ctx.baseFormData.changeFields?.includes('upstreamSettlementAdjustmentValue'),
    },
    {
      prop: 'serviceChainRestriction', // TODO
      name: '业务链限制',
      type: 'select',
      options: yesNoList,
      showTag: ctx.baseFormData.changeFields?.includes('serviceChainRestriction'),
    },
    {
      prop: 'paymentMethod', // TODO
      name: '回款方式',
      type: 'select',
      options: ctx.dictListMap?.GoodsTradeProject_paymentMethod || [],
      showTag: ctx.baseFormData.changeFields?.includes('paymentMethod'),
    },
    {
      prop: 'priceDifferAdjust', // TODO
      name: '价差调整',
      type: 'inputNumber',
      append: '天',
      showTag: ctx.baseFormData.changeFields?.includes('priceDifferAdjust'),
    },
    {
      prop: 'approveDate',
      name: '立项通过时间',
      disabled: true,
      type: 'input',
      showTag: ctx.baseFormData.changeFields?.includes('approveDate'),
    },
    {
      //备注
      prop: 'remark',
      name: '备注',
      type: 'textarea',
      span: 24,
      maxlength: 200,
      showTag: ctx.baseFormData.changeFields?.includes('remark'),
    },
  ];
};
